module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "adventure": _vm.adventure,
      "adventureId": _vm.adventureId,
      "chapter": _vm.selectedChapter,
      "chapterId": _vm.selectedChapterId
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "background-color": "white",
      "margin-top": "20px"
    },
    attrs: {
      "id": "page-chapters"
    }
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet"
  }, [_c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp mdl-cell--12-col",
    attrs: {
      "id": "adv-table"
    }
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "position": "absolute",
      "top": "6px",
      "right": "5px"
    },
    on: {
      "click": _vm.createChapter
    }
  }, [_vm._v("New Chapter")])])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable"
    }]
  }, _vm._l((_vm.adventure.chapters), function(chapter, chapterKey) {
    return _c('tr', {
      class: _vm.selectionClass(chapterKey),
      attrs: {
        "name": chapterKey
      },
      on: {
        "click": function($event) {
          _vm.selectChapter(chapterKey)
        }
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(chapter.name))]), _vm._v(" "), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric",
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "chapterKey": chapterKey
      },
      on: {
        "click": _vm.deleteChapter
      }
    }, [_c('i', {
      staticClass: "material-icons",
      attrs: {
        "chapterKey": chapterKey
      }
    }, [_vm._v("delete")])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--12-col-tablet mdl-grid"
  }, [(_vm.selectedChapterId) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-grid",
    staticStyle: {
      "background-color": "white",
      "text-align": "left"
    }
  }, [_c('h5', {
    staticClass: "mdl-cell--12-col"
  }, [_vm._v("Edit Chapter")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label ",
    class: {
      'is-dirty': _vm.selectedChapter.name
    }
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": _vm.selectedChapter.name
    },
    on: {
      "input": _vm.updateName
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v("Name...")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    class: {
      'is-dirty': _vm.selectedChapter.description
    }
  }, [_c('textarea', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "rows": "4",
      "id": "sample5"
    },
    domProps: {
      "value": _vm.selectedChapter.description
    },
    on: {
      "input": _vm.updateDescription
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample5"
    }
  }, [_vm._v("Description...")])])]), _vm._v(" "), (_vm.selectedChapter && _vm.selectedChapter.stages) ? _c('div', {
    staticClass: "mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label"
  }, [_c('select', {
    staticClass: "mdl-selectfield__select",
    attrs: {
      "id": "initialStage",
      "name": "initialStage"
    },
    on: {
      "change": _vm.changeInitialStage
    }
  }, _vm._l((_vm.selectedChapter.stages), function(stage, stageKey) {
    return _c('option', {
      attrs: {
        "value": "stage"
      },
      domProps: {
        "value": stageKey,
        "selected": _vm.selectedChapter.initialStage === stageKey
      }
    }, [_vm._v(_vm._s(stage.name))])
  })), _vm._v(" "), _c('label', {
    staticClass: "mdl-selectfield__label",
    attrs: {
      "for": "objTypeLbl"
    }
  }, [_vm._v("Initial Stage")]), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--12-col",
    attrs: {
      "id": "chapterSections"
    }
  }, [_c('router-link', {
    staticClass: "mdl-cell--4-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "to": ('/editor/' + _vm.adventureId + '/chapters/' + _vm.selectedChapterId + '/objects/')
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("widgets")]), _vm._v(" Objects")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-cell--4-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "to": ('/editor/' + _vm.adventureId + '/chapters/' + _vm.selectedChapterId + '/stages/')
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("nature_people")]), _vm._v(" Stages")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-cell--4-col mdl-button mdl-button--raised mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "to": ('/editor/' + _vm.adventureId + '/chapters/' + _vm.selectedChapterId + '/timeline/')
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("device_hub")]), _vm._v(" Timeline")])], 1)]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("collections_bookmark")]), _vm._v(" Chapters")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-selectfield__placeholder"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "tabindex": "-1"
    }
  }, [_vm._v("arrow_drop_down")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a7a1ff7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionChapters.vue
// module id = 311
// module chunks = 0